import { combineReducers } from 'redux';
import { AUTH } from './auth/reducer';

// Reducers
import appointment from 'views/practitioner/Appointment/reducers';
import appointments from 'views/practitioner/Appointments/reducer';
import common from 'views/practitioner/reducer/commonReducer';
import invoice from 'views/practitioner/CreateInvoice/reducer/invoiceReducer';
import reporting from 'views/practitioner/Reporting/reducer/index';
import createNewJob from 'views/practitioner/CreateNewJob/reducer/createNewJobReducer';
import jobs from 'views/practitioner/Jobs/reducer/jobsReducer';


const practitionerReducer = combineReducers({
  appointment,
  appointments,
  common,
  createNewJob,
  invoice,
  reporting,
  jobs
});

export default (state, action) => {
  if (action.type === AUTH.LOGOUT_SUCCESS || action.type === AUTH.LOGOUT_ERROR) {
    state = undefined;
  }
  return practitionerReducer(state, action);
};